<template>
  <div class="tms">
    <div class="tms-left">
      <div class="tabs">
        <div
          class="tabs-item"
          :class="[leftTabIndex === 1 ? 'active' : '']"
          @click="setLeftTab(1)"
        >
          页面管理
        </div>
        <div
          class="tabs-item"
          :class="[leftTabIndex === 2 ? 'active' : '']"
          @click="setLeftTab(2)"
        >
          组件库
        </div>
      </div>
      <div class="tab-contents">
        <!--页面列表-->
        <div class="editor-page-list-wrapper" v-if="leftTabIndex === 1">
          <page-list
            :pageList="pageList"
            :page="page + 1"
            :groupList="groupList"
            :groupIndex="groupIndex"
            :groupIndexList="groupIndexList"
            :pageIndex="pageIndex"
            :pageData="pageData"
            :originData="originData"
            :currentEditPageIndex="currentEditPageIndex"
            @copyPage="copyPage"
            @searchPage="searchPage"
            @addPage="addPage"
            @delPage="delPage"
            @changePage="changePage"
            @handleChange="handleChange"
            @handleCurrentChange="handleCurrentChange"
          ></page-list>
        </div>
        <!--模块列表-->
        <div class="editor-module-list-wrapper" v-if="leftTabIndex === 2">
          <module-list
            :pageData="pageData"
            :moduleList="moduleList"
            @addMod="addMod"
            @cloneEndHandler="cloneEndHandler"
          ></module-list>
        </div>
      </div>
    </div>

    <div class="tms-main" id="capture" ref="capture">
      <!--模块编辑展示区-->
      <editor
        :pageData="pageData"
        :currentEditModIndex="currentEditModIndex"
        @draggableEnd="draggableEnd"
        @editMod="editMod"
        @rmModConfirm="rmModConfirm"
        @upMod="upMod"
        @downMod="downMod"
        @copyMod="copyMod"
      ></editor>
    </div>

    <div class="tms-right">
      <div class="tabs">
        <div
          class="tabs-item"
          :class="[rightTabIndex === 1 ? 'active' : '']"
          @click="setRightTab(1)"
        >
          常规设置
        </div>
        <div
          class="tabs-item"
          :class="[rightTabIndex === 2 ? 'active' : '']"
          @click="setRightTab(2)"
        >
          组件设置
        </div>
        <!-- <div class="tabs-item" :class="[rightTabIndex === 3 ? 'active' : '']" @click="setRightTab(3)">模版</div> -->
      </div>
      <div class="tab-contents">
        <div v-if="pageData">
          <tms-page-config
            v-if="pageData && rightTabIndex === 1"
          ></tms-page-config>
          <tms-module-config
            v-if="currentModFields && rightTabIndex === 2"
          ></tms-module-config>
          <div class="empty" v-if="!currentModFields && rightTabIndex === 2">
            请选择需要设置的组件
          </div>
        </div>
        <div
          class="empty"
          v-else-if="rightTabIndex === 1 || rightTabIndex === 2"
        >
          <span
            v-if="rightTabIndex === 1"
            v-text="this.pageList.length > 0 ? '请选选择页面' : '请选创建页面'"
          ></span>
          <span v-if="rightTabIndex === 2">请选择需要设置的组件 </span>
        </div>
        <template-list
          v-if="rightTabIndex === 3"
          @selectTpl="selectTpl"
        ></template-list>
      </div>
    </div>

    <div class="tms-bottom-bar">
      <el-button
        v-if="pageData && pageData.page_id"
        size="medium"
        :data-track="
          JSON.stringify({
            t: '0005',
          })
        "
        @click="saveTemplate()"
        >存为模板</el-button
      >
      <el-button
        size="medium"
        :data-track="
          JSON.stringify({
            t: '0006',
          })
        "
        @click="preview()"
        >预览</el-button
      >
      <el-button
        size="medium"
        :data-track="
          JSON.stringify({
            t: '0007',
          })
        "
        @click="save()"
        type="primary"
        >保存</el-button
      >
      <el-button
        size="medium"
        :data-track="
          JSON.stringify({
            t: '0008',
          })
        "
        @click="publish()"
        type="primary"
        >发布</el-button
      >
      <el-button
        v-if="pageData && pageData.page_id"
        size="medium"
        class="copy-text"
        :data-clipboard-text="
          'https://yytools.mockuai.com/h5.html/browse?page_id=' +
            pageData.page_id
        "
        :data-track="
          JSON.stringify({
            t: '0009',
          })
        "
        @click="copyPageUrl()"
        >复制页面链接</el-button
      >
    </div>

    <transition name="fade">
      <div class="bg" @click="hideQrcode" v-if="previewQrcodeShow">
        <img class="preview-qrcode" :src="qrcode_url" alt="" />
      </div>
    </transition>

    <el-dialog
      title="预览"
      :visible.sync="dialogPreviewVisible"
      width="415px"
      top="30px"
      :before-close="handlePreviewClose"
    >
      <iframe
        ref="imageDom"
        id="iframePage"
        name="iframePage"
        v-if="dialogPreviewVisible"
        width="375px"
        height="667px"
        :src="previewUrl"
        frameborder="0"
        scrolling="auto"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button
          :data-track="
            JSON.stringify({
              t: '0010',
            })
          "
          v-popover:popCode
          >点击查看二维码</el-button
        >
        <el-button
          :data-track="
            JSON.stringify({
              t: '0011',
            })
          "
          @click="downLoadImg"
          >生成截图</el-button
        >
        <el-button
          :data-track="
            JSON.stringify({
              t: '0012',
            })
          "
          @click="dialogPreviewVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-popover ref="popCode" placement="right" width="300" trigger="click">
      <img
        width="280px"
        :src="
          'https://yytools-api.mockuai.com/api/test/page/qrcode?text=' +
            previewUrl
        "
        alt=""
      />
    </el-popover>

    <!-- 添加模板弹窗 -->
    <el-dialog title="添加至模板" :visible.sync="dialogTempVisible" width="40%">
      <el-form
        ref="form"
        :model="addTemplateData"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item label="模板名称：" prop="template_name">
          <el-input
            clearable
            v-model="addTemplateData.template_name"
            :maxlength="20"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板分类：" prop="category_id">
          <el-select v-model="addTemplateData.category_id" placeholder="请选择">
            <el-option
              v-for="item in templateCategoryList"
              :key="item.id"
              :label="item.category_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cover_img_url" label="模板封面：">
          <image-uploader
            ref="ImageUploader"
            :uploadedImg="addTemplateData.cover_img_url"
            @uploaded="handleUpload"
            class="small-image"
            tip="封面建议尺寸：375*665"
          ></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="addTemplateData.is_default_template"
            >是否设置置顶模板</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTempVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTemplate()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="发布成功"
      :visible.sync="publishDialogVisible"
      width="30%"
      custom-class="content-dialog"
      center
    >
      <div class="content">
        <div class="item">
          <span class="label">页面链接：</span>
          <a target="_blank" :href="urls.new_url" class="value">{{
            urls.new_url
          }}</a>
        </div>

        <div class="item">
          <span class="label">小程序链接：</span>
          <a target="javascript: void(0);" class="value">{{ urls.min_url }}</a>
        </div>

        <div class="item" v-if="oldUrlVisible">
          <span class="label">旧版页面链接：</span>
          <a target="_blank" :href="urls.old_url" class="value">{{
            urls.old_url
          }}</a>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="oldUrlVisible = !oldUrlVisible"
          >{{ !oldUrlVisible ? "显示" : "隐藏" }}旧版页面链接</el-button
        >
        <el-button type="primary" @click="publishDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import * as TMSFields from "@/plugin/tms/fields";
import modList from "@/plugin/tms/mod-list";
import templateList from "./components/TemplateList";
import pageList from "./components/PageList";
import moduleList from "./components/ModuleList";
import editor from "./components/Editor";
import _ from "lodash";
import { tmsMixin } from "@/js/common/mixin";
import bus from "@/js/common/bus.js";
import util from "@/js/util";
import Clipboard from "clipboard";
import html2canvas from "html2canvas";
import ImageUploader from "@/components/ImageUploader.vue";

export default {
  mixins: [tmsMixin],
  data() {
    return {
      previewUrl: "",
      dialogPreviewVisible: false,
      pageList: [],
      pageData: null,
      pageField: [],
      currentMod: null,
      moduleList: null,
      leftTabIndex: 1,
      rightTabIndex: 1,
      currentEditModIndex: "",
      currentEditPageIndex: "",
      originData: "",
      businessModuleCls: "",
      baseModuleCls: "",
      previewQrcodeShow: false,
      dialogVisible: false,

      qrcode_url: "",
      tpl: null,
      clipboard: "",
      name_like: "",
      isAjax: false,

      groupList: [],
      groupIndex: 0,
      pageIndex: 0,
      groupIndexList: [0],
      loadingInstance: null,
      page: 0, // 页面列表翻页

      urls: {
        new_url: "",
        old_url: "",
        min_url: "",
      },

      publishDialogVisible: false,
      oldUrlVisible: false,

      //添加模板
      canvasFile: "",
      templateCategoryList: [],
      dialogTempVisible: false,
      addTemplateData: {
        cover_img_url: "", // 封面
        template_name: "", // 模板名称
        page_id: "", // 对应页面Id
        page_data: {}, // 页面数据
        is_default_template: false, // 是否置顶
        category_id: "", // 模板分类
      },
      rules: {
        template_name: [
          { required: true, message: "请设置模板名称", trigger: "change" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        cover_img_url: [
          { required: true, message: "请添加封面", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    // 当前编辑模块
    currentModFields: function() {
      if (this.currentMod) {
        this.$store.commit(
          "updateComponents",
          TMSFields[this.currentMod.module_code]
        );
        return TMSFields[this.currentMod.module_code];
      }
    },
    ...mapGetters(["mediaUploadStatus"]),
  },
  watch: {
    currentMod(val) {
      this.$store.commit("updateConfig", this.currentMod);
      if (val && val.property_data) {
        this.$store.commit("updateCustomConfig", val.property_data);
      }
    },
    pageData(val) {
      this.$store.commit("updatePageData", val);
    },
  },

  components: {
    templateList,
    pageList,
    editor,
    moduleList,
    ImageUploader,
  },
  created() {
    if (!lib.login.isLogin()) {
      lib.login.goLogin();
    }
    this.template_id = this.$route.query.template_id || "";
    this.request();
    this.$store.commit("updateRuleComponentList", TMSFields.page);
    this.getSellerMenu();
    this.getTemplateCategory();
  },

  mounted() {},
  methods: {
    //保存模板-使用的分类
    getTemplateCategory() {
      lib.tmsapi.get({
        api: "api/test/template_category/list",
        data: {},
        success: (data) => {
          this.templateCategoryList = data.data;
        },
        error: (data) => {},
        complete: () => {},
      });
    },
    //使用模板
    getTemplate() {
      lib.tmsapi.get({
        api: "api/test/template/detail",
        data: {
          id: this.template_id,
        },
        success: (res) => {
          this.pageData = {
            type: 1,
            name: `模板-${res.data.template_name}`,
            nav_name: `模板-${res.data.template_name}`,
            background_type: res.data.pageData.background_type * 1,
            background_color: res.data.pageData.background_color,
            page_link_type: "detail",
            app_type: res.data.pageData.app_type,
            description: res.data.pageData.description || '',
            share_image: res.data.pageData.share_image || '',
            status: 0,
            module_list: res.data.pageData.module_list,
          };
          this.currentMod = null;
          this.rightTabIndex = 1;
          this.groupList[0].pageList.unshift(this.pageData);
          this.$set(this.groupList, 0, this.groupList[0]);
          this.currentEditPageIndex = 0;
          this.pageIndex = this.currentEditPageIndex;
          this.originData = JSON.stringify(res.data.pageData);
        },
        error: () => {
          this.$message.error("请求失败!");
        },
        complete: () => {},
      });
    },
    //下载图片
    downLoadImg() {
      const ifrmae = this.$refs.imageDom;
      const ifW = ifrmae.contentWindow;
      const body = ifW.document.body;
      html2canvas(body, {
        useCORS: true, //页面内使用了跨域的图片需要加useCORS: true，不然图片截图时会不存在
        width: body.clientWidth,
        height: body.clientHeight,
        scrollY: 0,
        scrollX: 0,
      }).then((canvas) => {
        // canvas为转换后的Canvas对象
        let oImg = new Image();
        oImg = canvas.toDataURL("image/png"); // 导出图片
        var oA = document.createElement("a");
        oA.download = this.pageData.name; // 设置下载的文件名，默认是'下载'
        oA.href = oImg;
        document.body.appendChild(oA);
        oA.click();
        oA.remove(); // 下载之后把创建的元素删除
      });
    },
    // 截图
    screenshot() {
      const ifrmae = this.$refs.imageDom;
      const ifW = ifrmae.contentWindow;
      const body = ifW.document.body;
      html2canvas(body, {
        useCORS: true, //页面内使用了跨域的图片需要加useCORS: true，不然图片截图时会不存在
        width: body.clientWidth,
      }).then((canvas) => {
        let base64 = canvas.toDataURL();
        this.dialogPreviewVisible = false;
        this.dialogTempVisible = true;

        let blob = this.dataURLtoBlob(base64);
        let file = this.blobToFile(blob, "a.png");
        this.getUploadParams(file);
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          this.loading.close();
        });
      });
    },
    // base64 处理
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    // 获取上传的参数
    getUploadParams(file) {
      let ext = file.name.split(".").pop();
      // 名字由时间戳 ＋ 1000-9999随机数
      this.filename = `${new Date().getTime()}${util.randomNum(
        1000,
        9999
      )}.${ext}`;

      lib.api.get({
        api: "ec/c/tool/upload/auth/get",
        data: {
          filename: this.filename,
        },
        success: (res) => {
          this.uploadParams = res.data.file_upload_auth;
          this.uploadParams.file = file;
          this.uploadOss(this.uploadParams);
        },
        error: (err) => {
          if (err && err.msg && err.code != 30002) {
            this.$message.error(err.msg);
          }
        },
      });
    },
    uploadOss(formData) {
      console.log(formData);
      var request = new FormData();
      request.append("OSSAccessKeyId", formData.oss_accesskey_id);
      request.append("policy", formData.policy);
      request.append("Signature", formData.signature);
      request.append("key", this.filename);
      request.append("success_action_status", "200");
      request.append("file", formData.file);
      $.ajax({
        url: formData.host,
        processData: false,
        cache: false,
        async: false,
        contentType: false,
        type: "post",
        data: request,
        success: () => {
          this.addTemplateData.cover_img_url = `https://mktv-in-cdn.mockuai.com/${this.filename}`; //下载链接
        },
      });
    },
    // 添加模板
    addTemplate() {
      this.addTemplateData.page_data = JSON.stringify(this.pageData);
      this.addTemplateData.page_id = this.pageData.page_id;
      lib.tmsapi.post({
        api: "api/test/template/add",
        data: this.addTemplateData,
        success: (res) => {
          this.$message.success("模板添加成功!");
          this.dialogTempVisible = false;
        },
        error: () => {
          this.$message.error("模板添加失败!");
          this.dialogTempVisible = false;
        },
      });
    },
    handleUpload(src) {
      this.addTemplateData.cover_img_url = src;
    },
    saveTemplate() {
      this.addTemplateData.template_name = this.pageData.name;
      this.getPreviewUrl();
      setTimeout(() => {
        this.loading = this.$loading({
          lock: true,
          text: "页面截图生成中5秒后完成",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout(() => {
          this.screenshot();
        }, 1000);
      }, 1500);
    },
    copyPageUrl() {
      const clipboard = new Clipboard(".copy-text");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功！");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("复制失败！");
        clipboard.destroy();
      });
    },
    handlePreviewClose() {
      this.dialogPreviewVisible = false;
    },
    handleCurrentChange(page) {
      this.page = page * 1 - 1;
      this.request();
    },
    //根据用户信息返回对应的菜单和功能
    getSellerMenu() {
      var moduleData = _.cloneDeep(modList);
      let newModuleList = {};
      newModuleList.base = moduleData.base;
      newModuleList.business = moduleData.business;
      newModuleList.activeList = moduleData.activeList;
      this.moduleList = newModuleList;
    },
    cloneEndHandler(event) {
      this.moduleListSort(event.newIndex);
    },
    draggableEnd(event) {
      // 重新设置index
      if (event.oldIndex === this.currentEditModIndex) {
        this.currentEditModIndex = event.newIndex;
      }
      this.moduleListSort();
    },
    // 组件重新排序，保证top_nav在顶部，bottom_nav在底部
    moduleListSort() {
      if (this.pageData && this.pageData.module_list) {
        let length = this.pageData.module_list.length;
        if (length > 1) {
          let moduleList = _.cloneDeep(this.pageData.module_list),
            topIndex = -1,
            bottomIndex = -1,
            topMod,
            bottomMod;
          moduleList.map((val, index) => {
            if (val.module_code === "bottom_nav") {
              bottomIndex = index;
            }
          });
          if (bottomIndex > -1) {
            if (topIndex > bottomIndex) {
              bottomIndex++;
            }
            bottomMod = this.pageData.module_list[bottomIndex];
            this.pageData.module_list.splice(bottomIndex, 1);
            this.pageData.module_list.push(bottomMod);
          }
        }
      }
    },
    //获取页面列表
    request() {
      let params = {};
      params.page = this.page;
      params.count = 15;
      params.name_like = this.name_like;
      lib.tmsapi.get({
        api: "api/test/page/list",
        data: params,
        success: (data) => {
          this.loadData(data);
        },
        error: (data) => {
          //              this.$message.error(data.msg);
        },
        complete: () => {
          this.isAjax = false;
        },
      });
    },

    //处理数据
    loadData(object) {
      this.groupList = [
        {
          id: 0,
          name: "默认组",
        },
      ];
      this.groupList[0].pageList = object.data.data;

      this.groupList[0].pageList = object.data;
      this.$set(this.groupList, 0, this.groupList[0]);

      if (object.data.length > 0) {
        if (this.template_id) {
          this.getTemplate();
        } else {
          this.changePage(this.pageIndex, 0);
        }
      } else {
        this.pageData = null;
        this.rightTabIndex = 1;
      }
    },

    getNewPage(index, isSeach = false) {
      return new Promise((resolve, reject) => {
        lib.tmsapi.get({
          api: "api/test/page/list",
          data: {
            page: 0,
            count: 15,
            name_like: this.name_like,
          },
          success: (data) => {
            this.groupList[0].pageList = data.data;
            this.$set(this.groupList, index, this.groupList[0]);

            if (data.data.length > 0) {
              this.changePage(this.pageIndex, 0);
            } else {
              this.pageData = null;
              this.rightTabIndex = 1;
            }
            resolve(data.data);
          },
          error: (data) => {
            //                  this.$message.error(data.msg);
          },
          complete: () => {
            this.isAjax = false;
          },
        });
      });
    },
    // 设置左侧Tab
    setLeftTab(index) {
      this.leftTabIndex = index;
    },
    // 设置右侧Tab
    setRightTab(index) {
      this.rightTabIndex = index;
    },
    // 新建页面
    addPage(gIndex) {
      if (this.checkPageModify()) {
        this.groupIndex = gIndex;
        this.pageData = {
          type: 1,
          name: "新页面",
          nav_name: "新页面",
          background_type: 1,
          background_color: "#F7F7F7",
          page_link_type: "detail",
          app_type: "seller",
          description: '',
          share_image: '',
          status: 0,
          module_list: [],
        };
        this.currentMod = null;
        this.rightTabIndex = 1;
        this.groupList[0].pageList.unshift(this.pageData);
        this.$set(this.groupList, 0, this.groupList[0]);
        this.currentEditPageIndex = 0;
        this.pageIndex = this.currentEditPageIndex;
      }
    },
    // 搜索页面
    searchPage(name_like) {
      this.name_like = name_like;
      this.page = 0;
      this.pageIndex = 0;
      this.groupIndex = 0;
      this.request();
    },
    // 切换页面
    changePage(pageIndex, groupIndex) {
      // 如果正在加载页面，不让切换页面
      if (this.checkPageModify()) {
        this.groupIndex = 0;
        this.currentEditModIndex = 0;
        this.pageIndex = pageIndex;
        this.getPage(this.groupList[0].pageList[pageIndex].page_id, pageIndex);
      }
      this.currentMod = "";
    },

    // 添加组件
    addMod(mod, index) {
      if (this.pageData && this.pageData.module_list) {
        if (this.checkModuleListAdd(mod)) {
          let flag = false,
            length = this.pageData.module_list.length;
          // 没有组件
          if (length === 0) {
            this.pageData.module_list.push(_.cloneDeep(mod));
          } else {
            // 顶部导航组件
            if (mod.module_code === "top_nav") {
              this.pageData.module_list.unshift(_.cloneDeep(mod));
            } else {
              this.pageData.module_list.map((val) => {
                if (val.module_code === "bottom_nav") {
                  flag = true;
                  return;
                }
              });
              if (index !== undefined) {
                this.pageData.module_list.splice(index, 0, _.cloneDeep(mod));
              } else {
                this.pageData.module_list.push(_.cloneDeep(mod));
                // 元素滚动到底部
                this.$nextTick(() => {
                  this.$refs.capture.scrollTop = this.$refs.capture.scrollHeight;
                });
              }
              if (flag === true) {
                this.exchangeMod(length - 1, length);
              }
            }
          }
        }
      } else {
        this.$message.error("请先选择页面");
      }
    },
    // 点击页面中的组件
    editMod(item, index) {
      if (this.mediaUploadStatus && this.currentEditModIndex !== index) {
        this.$message.error("文件正在上传，请等待上传完成");
      } else {
        this.currentEditModIndex = index;
        this.rightTabIndex = 2;
        this.currentMod = item;
      }
    },
    // 获取页面
    getPage(id, index) {
      var that = this;
      this.isAjax = true;
      lib.tmsapi.get({
        api: "api/test/page/get",
        data: {
          id: id,
        },
        success: (data) => {
          this.currentEditPageIndex = index;
          this.pageIndex = this.currentEditPageIndex;
          this.rightTabIndex = 1;
          if (data.data && !data.data[0].module_list) {
            data.data.module_list = [];
          }
          data.data[0].module_list = JSON.parse(data.data[0].module_list);
          this.pageData = data.data[0];
          if (!this.pageData.app_type || this.pageData.app_type == "0") {
            this.pageData.app_type = "seller";
          }
          this.originData = JSON.stringify(that.pageData);
        },
        error: (data) => {
          this.$message.error(data.msg);
        },
        complete: () => {
          this.isAjax = false;
        },
      });
    },
    // 删除页面
    delPage(id, pageIndex, groupIndex) {
      this.groupIndex = groupIndex;
      // 删除新页面时不需要保存页面
      if (this.checkPageModify()) {
        lib.tmsapi.post({
          api: "api/test/page/delete",
          data: {
            id: id,
          },
          success: () => {
            this.$message.success("删除成功");
            this.currentEditPageIndex = "";
            this.pageIndex = 0;
            this.request();
            bus.$emit("getTarget", "pageChange");
          },
          error: () => {
            this.$message.error("请求失败!");
          },
          complete: () => {},
        });
      }
      this.currentMod = "";
    },
    // 复制页面
    copyPage(item) {
      let id = item.page_id;
      if (this.checkPageModify()) {
        lib.tmsapi.post({
          api: "api/test/page/copy",
          data: {
            id: id,
          },
          success: () => {
            this.$message.success("复制成功");
            this.currentEditPageIndex = "";
            this.pageIndex = 0;
            this.request();
            bus.$emit("getTarget", "pageChange");
          },
          error: () => {
            this.$message.error("请求失败!");
          },
          complete: () => {},
        });
      }
    },
    // 删除模块确认
    rmModConfirm(index) {
      this.$confirm("确定要删除此模块？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.rmMod(index);
        })
        .catch(() => {
          return;
        });
    },
    // 删除页面中的组件
    rmMod(index) {
      if (this.pageData) {
        if (index === this.currentEditModIndex) {
          this.currentMod = "";
        }
        this.pageData.module_list.splice(index, 1);
      }
    },
    // 上移组件
    upMod(index) {
      if (index > 0) {
        this.exchangeMod(index - 1, index);
        this.currentEditModIndex = index - 1;
      }
      this.moduleListSort();
    },
    // 下移组件
    downMod(index) {
      if (this.pageData) {
        if (index > -1 && index < this.pageData.module_list.length - 1) {
          this.exchangeMod(index, index + 1);
          this.currentEditModIndex = index + 1;
        }
        this.moduleListSort();
      }
    },
    // 切换组件
    exchangeMod(a, b) {
      if (this.pageData) {
        let list = this.pageData.module_list;

        let aObj = list[a];
        let bObj = list[b];

        // 交换
        this.$set(this.pageData.module_list, a, bObj);
        this.$set(this.pageData.module_list, b, aObj);
      }
    },
    // 检查页面是否被修改
    checkPageModify() {
      if (this.originData !== JSON.stringify(this.pageData) && this.pageData) {
        this.$confirm("页面正在编辑中，请先保存当前页面", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.save();
          })
          .catch(() => {});
        return false;
      } else {
        return true;
      }
    },
    // 保存页面
    save() {
      let data = "";
      data = _.cloneDeep(this.pageData);
      data.status = 1;
      this.setMediaUploadStatus(false);
      if (data.module_list.length === 0) {
        this.$confirm("确定要保存空页面？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            data.module_list = JSON.stringify(data.module_list);
            this.isNew = true;
            this.savePage(data);
          })
          .catch(() => {
            this.getNewPage(this.groupIndex);
            return;
          });
      } else {
        data.module_list = JSON.stringify(data.module_list);
        this.savePage(data);
      }
    },
    savePage(data) {
      data.group_id = this.groupList[this.groupIndex].id;
      this.pageData.id = data.page_id || "";
      this.$message.success("保存成功！");
      this.originData = JSON.stringify(this.pageData);
      this.saveMongo(this.pageData);
      bus.$emit("getTarget", "pageChange");
    },
    saveMongo(pageData) {
      lib.tmsapi.post({
        api: "api/test/page/add",
        data: {
          id: pageData.id,
          name: pageData.name,
          module_list: JSON.stringify(pageData.module_list),
          background_color: pageData.background_color,
          background_type: pageData.background_type,
          page_link_type: pageData.page_link_type,
          app_type: this.pageData.app_type,
          description: this.pageData.description,
          share_image: this.pageData.share_image,
        },
        success: (data) => {
          if (!pageData.id) {
            this.pageData.page_id = data.data.page_id;
            this.originData = JSON.stringify(this.pageData);
          }
          if (this.template_id) {
            this.template_id = "";
            this.$router.replace({
              path: "/tms",
            });
            return;
          }
          if (this.isNew) {
            this.request();
            this.isNew = false;
          }
        },
        error: (data) => {
          console.log(data);
        },
        complete: () => {
          this.isAjax = false;
        },
      });
    },
    // 预览页面
    preview() {
      this.getPreviewUrl();
    },
    getHref() {
      var url = window.location.href;
      var urlstr = url.split("/"); //以“/”进行分割
      var urls = "";
      if (urlstr[2]) {
        urls = urlstr[0] + "//" + urlstr[2];
      }
      return urls;
    },
    // 获得预览
    getPreviewUrl() {
      if (this.checkPageModify()) {
        if (this.pageData) {
          if (this.pageData.page_id) {
            lib.tmsapi.post({
              api: "api/test/page/preview/json",
              data: {
                id: this.pageData.page_id,
                name: this.pageData.name,
                module_list: JSON.stringify(this.pageData.module_list),
                background_color: this.pageData.background_color,
                background_type: this.pageData.background_type,
                page_link_type: this.pageData.page_link_type,
                app_type: this.pageData.app_type,
                description: this.pageData.description,
                share_image: this.pageData.share_image,
              },
              success: (data) => {
                let url = "";
                // json 形式
                url =
                  "/h5.html/browse?page_id=" +
                  this.pageData.page_id +
                  "&isPreview=true";
                // h5 形式
                // url = 'https://yytools-api.mockuai.com/app/temp_activity/' + this.pageData.page_id + '.html'
                url = this.getHref() + url;
                this.previewUrl = url;
                this.dialogPreviewVisible = true;
              },
              error: (data) => {
                console.log(data);
              },
              complete: () => {
                this.isAjax = false;
              },
            });
          } else {
            this.$message.error("请先保存页面");
          }
        } else {
          this.$message.error("请先创建页面");
        }
      }
    },
    // 发布页面
    publish() {
      var that = this;
      if (this.checkPageModify()) {
        if (this.pageData) {
          if (this.pageData.page_id) {
            lib.tmsapi.post({
              api: "api/test/page/publish",
              data: {
                id: this.pageData.page_id,
                name: this.pageData.name,
                module_list: JSON.stringify(this.pageData.module_list),
                background_color: this.pageData.background_color,
                background_type: this.pageData.background_type,
                page_link_type: this.pageData.page_link_type,
                app_type: this.pageData.app_type,
                description: this.pageData.description || '',
                share_image: this.pageData.share_image || '',
              },
              success: (data) => {
                let url = "",
                  url_wdzb = "",
                  url_c_app = "",
                  new_url = "";
                url_wdzb =
                  "https://cdn.wudizhubo.com/tms/" +
                  that.pageData.page_id +
                  ".html?t=" +
                  new Date().getTime() +
                  "&title=page_id_" +
                  that.pageData.page_id;
                url =
                  "https://cdn.mockuai.com/tms/" +
                  that.pageData.page_id +
                  ".html?t=" +
                  new Date().getTime() +
                  "&title=page_id_" +
                  that.pageData.page_id;
                url_c_app =
                  "https://cdn.mockuai.com/tms/" +
                  that.pageData.page_id +
                  ".html?t=" +
                  new Date().getTime() +
                  "&title=page_id_" +
                  that.pageData.page_id;
                new_url =
                  "https://yytools.mockuai.com/h5.html/browse?page_id=" +
                  that.pageData.page_id;

                this.publishDialogVisible = true;

                this.urls = {
                  new_url: new_url,
                  old_url: url,
                  min_url: `pages/module/web/webpage?src=${encodeURIComponent(
                    new_url
                  )}`,
                };

                console.log(data);
              },
              error: (data) => {
                console.log(data);
              },
              complete: () => {
                this.isAjax = false;
              },
            });
          } else {
            this.$message.error("请先保存页面");
          }
        } else {
          this.$message.error("请先创建页面");
        }
      }
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 隐藏预览二维码
    hideQrcode() {
      this.previewQrcodeShow = false;
    },
    handleChange(groupIndexList, index) {
      this.groupIndexList = groupIndexList;

      if (this.checkPageModify()) {
        var that = this;
        this.groupIndex = parseInt(index);
        this.currentEditPageIndex = 0;
        this.pageIndex = 0;
        this.getNewPage(this.groupIndex);
      }
    },
    // 复制组件
    copyMod() {
      if (this.currentEditModIndex || this.currentEditModIndex === 0) {
        this.clipboard = _.cloneDeep(
          this.pageData.module_list[this.currentEditModIndex]
        );
        this.paste();
        this.$message.success("复制成功!");
      } else {
        this.$message.error("请先选择组件");
      }
    },
    // 粘贴组件
    paste() {
      if (this.clipboard) {
        this.addMod(this.clipboard, this.currentEditModIndex);
      } else {
        this.$message.error("请先复制组件");
      }
    },
    ...mapMutations({
      setMediaUploadStatus: "SET_MEDIA_UPLOAD_STATUS",
    }),
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  text-align: center;
  .dialog-content-tips {
    font-size: 13px;
    color: #999;
    line-height: 20px;
  }
  .dialog-content-link {
    padding: 26px 0 19px;
    font-size: 18px;
    font-weight: bold;
  }
}
.tms {
  display: flex;
  position: relative;
  color: #666;
  padding-bottom: 6px;

  .tms-bottom-bar {
    position: fixed;
    height: 50px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    box-shadow: 2px 2px 6px 0 rgba(136, 156, 176, 0.2), inset 0 1px 0 0 #dcdfe6;
    text-align: center;
    padding: 9px 0 0 0;
  }

  .tabs {
    width: 100%;
    display: flex;
    font-size: 14px;

    .tabs-item {
      height: 60px;
      background: #f2f2f2;
      flex: 1;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      &.active {
        background: #fff;
        color: #4a8ef7;
      }
    }
  }

  .tab-contents {
    height: 760px;
    width: calc(100% + 20px);

    .editor-page-list-wrapper {
      overflow: hidden;
      width: 100%;
    }

    .editor-module-list-wrapper {
      height: 760px;
      width: 100%;
      overflow: auto;
    }
  }

  .tms-left {
    flex: 0 0 224px;
    width: 224px;
    overflow: hidden;
    margin: 6px 0 0 0;
    background: #ffffff;
    box-shadow: 2px 2px 6px 0 rgba(136, 156, 176, 0.2);
    border-radius: 6px;

    .tab-contents {
      height: 760px;
      width: 100%;
    }
  }

  .tms-main {
    flex: 0 0 435px;
    width: 435px;
    height: 850px;
    padding: 24px 52px 24px 12px;
    margin-right: 2px;
    margin-top: 6px;
    margin-left: 10px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    background: #fff;
    .content {
      width: 373px;
    }
  }

  .tms-right {
    flex: 1;
    margin: 6px 0 0 0;
    background: #ffffff;
    box-shadow: 2px 2px 6px 0 rgba(136, 156, 176, 0.2);
    min-width: 400px;
    overflow: hidden;

    .tab-contents {
      overflow-y: auto;
      padding-right: 20px;

      .empty {
        line-height: 665px;
        height: 665px;
        text-align: center;
        font-size: 16px;
        padding-top: 33px;
      }
    }
  }
}

.bg {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;

  .preview-qrcode {
    width: 200px;
    background: #fff;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.container-fluid {
  padding: 10px 16px 10px 10px !important;
}

.content-dialog {
  .content {
    .item {
      padding: 10px 0;
    }
  }
}
</style>
